import React from 'react';
import { ArrowRight, Home, Briefcase, Boxes, Truck, CheckCircle } from 'lucide-react';
import SEO from '../components/SEO';

const HouseholdBusinessStorage = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <SEO
                title="Household & Business Storage Near Richland Chambers Lake | V&D Storage"
                description="Drive-up household and business storage units on FM 416, near Richland Chambers Lake. Ground-level access for contractors, homeowners, and local businesses. Rent online today."
                canonical="/household-business-storage-streetman"
            />
            {/* Hero Section */}
            <section className="bg-green-700 text-white py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">
                        Household & Business Storage
                    </h1>
                    <p className="text-xl text-green-100 max-w-3xl mx-auto mb-8">
                        The perfect solution for Lake House builders, Renovators, and Local Contractors.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="https://vdstoragestreetman.storageunitsoftware.com/pages/rent"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                if (window.gtag) {
                                    window.gtag('event', 'conversion_intent', {
                                        'event_category': 'lead',
                                        'event_label': 'household_hero_rates',
                                        'facility_name': 'VD Storage Streetman'
                                    });
                                }
                            }}
                            className="inline-flex items-center px-8 py-3 text-lg font-semibold text-green-700 bg-white rounded-lg hover:bg-gray-100 transition-colors shadow-lg"
                        >
                            See Storage Rates
                            <ArrowRight className="ml-2 h-5 w-5" />
                        </a>
                    </div>
                </div>
            </section>

            {/* Split Content */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {/* For Homeowners */}
                        <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 shadow-sm">
                            <div className="inline-block p-3 bg-green-100 rounded-full mb-6">
                                <Home className="h-8 w-8 text-green-700" />
                            </div>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                For Homeowners & Builders
                            </h2>
                            <p className="text-lg text-gray-600 mb-6">
                                Building your dream lake house? Don't clutter your construction site.
                                Keep your furniture and decor safe until moving day.
                            </p>
                            <ul className="space-y-3">
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-600 mr-2 mt-1" />
                                    <span>Store furniture while building</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-600 mr-2 mt-1" />
                                    <span>Protect personal items during renovation</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-600 mr-2 mt-1" />
                                    <span>Declutter your garage</span>
                                </li>
                            </ul>
                        </div>

                        {/* For Business */}
                        <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 shadow-sm">
                            <div className="inline-block p-3 bg-blue-100 rounded-full mb-6">
                                <Briefcase className="h-8 w-8 text-blue-700" />
                            </div>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                For Local Businesses
                            </h2>
                            <p className="text-lg text-gray-600 mb-6">
                                Secure inventory space for local contractors. Access your tools and materials
                                quickly without paying commercial retail prices.
                            </p>
                            <ul className="space-y-3">
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-blue-600 mr-2 mt-1" />
                                    <span>Contractor tool storage</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-blue-600 mr-2 mt-1" />
                                    <span>Inventory management</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-blue-600 mr-2 mt-1" />
                                    <span>Archive document storage</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HouseholdBusinessStorage;
